module.exports = __webpack_public_path__ + "img/1765.8130bda8.gif";